import React from 'react';

const DeletePromptIcon = () => (
    <svg width="64" height="64" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.25 4.98499C13.7525 4.73749 11.24 4.60999 8.735 4.60999C7.25 4.60999 5.765 4.68499 4.28 4.83499L2.75 4.98499" stroke="#F04248" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.875 4.2275L7.04 3.245C7.16 2.5325 7.25 2 8.5175 2H10.4825C11.75 2 11.8475 2.5625 11.96 3.2525L12.125 4.2275" stroke="#F04248" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.6375 7.35501L14.15 14.9075C14.0675 16.085 14 17 11.9075 17H7.09255C5.00005 17 4.93255 16.085 4.85005 14.9075L4.36255 7.35501" stroke="#F04248" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.24756 12.875H10.7451" stroke="#F04248" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.625 9.875H11.375" stroke="#F04248" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);

export default DeletePromptIcon;